// src/components/intake/IntakeSpouseGate.js
//
// Ticket 064 (screen 2.3). The intake's own copy of the Calculator's spouse gate
// (page-private UI is copied, not imported, 053 D9). Yes / No; there is no
// "Not sure". Only shown to people who are married.

import React from 'react'
import IntakeOptionButton from './IntakeOptionButton'
import { SPOUSE_HAS_INCOME_QUESTION } from '../../lib/intake/intakeConfig'

export default function IntakeSpouseGate({ value, onChange }) {
  return (
    <div className="u-stack-sm">
      <div className="u-form-label">{SPOUSE_HAS_INCOME_QUESTION}</div>
      <div className="u-stack-xs">
        <IntakeOptionButton label="Yes" selected={value === true} onClick={() => onChange(true)} />
        <IntakeOptionButton label="No" selected={value === false} onClick={() => onChange(false)} />
      </div>
    </div>
  )
}
